import Artigo from '../components/artigo'
import BannerBlog from '../components/bannerBlog'
import Rodape from '../components/rodape'

export default function ArtigoPage() {
  const isSmallScreen = window.innerWidth < 640
  return (
    <>
      {!isSmallScreen ? <BannerBlog /> : []}
      <Artigo />
      <Rodape />
    </>
  )
}
